import { createContext, useContext } from "react";

export interface AccessCountdownState {
    /** True while the user is being signed out (no access / counting down). */
    isSigningOut: boolean;
    /** Seconds left before the redirect to /login, or null until the countdown starts. */
    secondsRemaining: number | null;
    /** Message shown in the access-denied notice. */
    message: string;
}

export const AccessCountdownContext = createContext<AccessCountdownState>({ isSigningOut: false, secondsRemaining: null, message: "" });

/** Read the pending access-denied state so the layout can render the notice in place. */
export function useAccessCountdown(): AccessCountdownState {
    return useContext(AccessCountdownContext);
}
